var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-block',{style:(("font-family: monospace; font-size: 13.2px; background-color: " + _vm.color + ";")),attrs:{"width":"auto","padding":"10px 10px","margin":_vm.margin}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])}
var staticRenderFns = []

export { render, staticRenderFns }